export default __webpack_public_path__ + "static/media/BPT.fc144f02.svg";